/**
 * Substitutes '{{s}}' in a given string by '' if the phrase should be in
 * singular form or by 's' if it should be in plural form.
 * @param len quantity of the items mentioned in the phrase
 * @param str the phrase to be transformed
 * @returns the `phrased` edited to either singular or plural mode, according to `length`
 */
export const transformSingularPlural = (len: number, str: string): string => str.replace(/\{\{s}}/g, len <= 1 ? '' : 's');
